
import getById from "./getById";
import forOwn from 'mout/object/forOwn'
export default function checkLicenseLimit (licenseId, licenses, users) {
  const license= getById(licenses, licenseId)
  let usersTobeAddedCount = 0;
  if(license)
  {
    forOwn(users,(user)=>{
        if(user.licenses)
        {
            if(!user.licenses[license.id])
            {
                usersTobeAddedCount++
            }
        }
        else if (!user.licenses)
        {
            usersTobeAddedCount++;
        }
      })
      if(usersTobeAddedCount > (license.licensedMax - license.licensedCount))
      {
          return true
      }
  }
  return false;
}
export function checkLicenseLimitForSingleItem (licenseId, licenses,userId,users) {
    const license= getById(licenses, licenseId)
    const user = getById(users,userId);
    if(license)
    {
        if(user.licenses)
        {
            if(!user.licenses[license.id])
            {
                if(license.licensedMax <= license.licensedCount)
                {
                    return true
                }
            }
        }
        else {
            if(license.licensedMax <= license.licensedCount)
            {
                return true
            }
        }
        
    }
    return false;
  }


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/checkLicenseLimit.js